import { motion } from "framer-motion";

const FEED = [
  {
    severity: "Critical",
    text: "Credential found in breach dump",
    source: "Source: Dark Web Forum [xss.is]",
    time: "2m ago",
  },
  {
    severity: "Warning",
    text: "Typosquat domain registered",
    source: "Target: corp-cybrmon.co.in",
    time: "15m ago",
  },
  {
    severity: "Warning",
    text: "API Key Exposed",
    source: "Source: Public GitHub Repo",
    time: "1h ago",
    faded: true,
  },
];

const SEVERITY_STYLE = {
  Critical: "bg-severity-critical/20 text-severity-critical",
  Warning: "bg-severity-warning/20 text-severity-warning",
};

export default function LiveThreatFeed() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.55, delay: 0.1 }}
      className="flex-1 w-full max-w-md relative"
    >
      <div className="bg-surface-dark rounded-2xl p-card-padding relative overflow-hidden shadow-2xl border border-glass">
        <div className="scan-line" />
        <div className="flex justify-between items-center mb-stack-lg border-b border-surface-variant/20 pb-4">
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full bg-severity-good pulse-dot" />
            <span className="font-eyebrow text-eyebrow text-surface-bright uppercase">Live Feed</span>
          </div>
          <span className="font-data-mono text-data-mono text-tertiary-fixed-dim">342 Signals / 7d</span>
        </div>
        <div className="flex flex-col gap-4">
          {FEED.map((item) => (
            <div
              key={item.text}
              className={`flex flex-col gap-2 p-3 bg-white/5 rounded-lg border border-white/5 ${item.faded ? "opacity-70" : ""}`}
            >
              <div className="flex justify-between items-start">
                <span className={`font-data-mono text-[10px] px-2 py-1 rounded-full uppercase tracking-wider ${SEVERITY_STYLE[item.severity]}`}>
                  {item.severity}
                </span>
                <span className="font-data-mono text-[10px] text-tertiary-container">{item.time}</span>
              </div>
              <p className="font-data-mono text-sm text-surface-bright leading-tight">{item.text}</p>
              <span className="font-data-mono text-[11px] text-secondary-fixed-dim mt-1">{item.source}</span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
